package com.ai.mitra.domain.use_cases

import com.ai.mitra.domain.respository.GeminiRepository
import org.koin.core.component.KoinComponent

class UpdatePendingUseCase(private val geminiRepository: GeminiRepository) : KoinComponent {
    suspend fun updatePending(
        messageId: String,
        isPending: Boolean
    ) {
        geminiRepository.updatePendingStatus(messageId, isPending)
    }

}